import banner from "../../../courses/module-2/img7.png";

const modulo7 = {
  courseId: "cripto-blockchain",
  id: "modulo-7",
  title:
    "🧩 MÓDULO 7: Aprender y ganar cripto – Educación con recompensas reales",
  estimatedDuration: "45 minutos",
  format: "Lectura + actividad reflexiva",
  bannerUrl: banner,
  sections: [
    {
      id: "que-es",
      navLabel: "¿Qué es Learn & Earn?",
      title: "🎯 ¿Qué es Learn & Earn?",
      content: [
        {
          type: "paragraph",
          text: "Learn & Earn (Aprende y gana) es una modalidad educativa en la que los usuarios reciben pequeñas recompensas en criptomonedas a cambio de aprender sobre proyectos Web3.",
        },
        {
          type: "paragraph",
          text: "En lugar de solo estudiar teoría, este modelo ofrece:",
        },
        {
          type: "list",
          items: [
            "Mini-lecciones prácticas, usualmente en forma de video o texto interactivo.",
            "Cuestionarios o retos, que ponen a prueba tu comprensión.",
            "Recompensas en tokens, directamente en tu wallet tras completar cada actividad.",
          ],
        },
        {
          type: "paragraph",
          text: "Es una excelente forma de aprender mientras ganas, sin necesidad de inversión previa. Ideal para jóvenes que están comenzando en el mundo cripto.",
        },
      ],
    },
    {
      id: "funcionamiento",
      navLabel: "¿Cómo funciona?",
      title: "📚 ¿Cómo funciona?",
      content: [
        {
          type: "orderedList",
          items: [
            "Creas una cuenta en una plataforma que ofrezca Learn & Earn.",
            "Eliges una lección activa (por ejemplo: “¿Qué es Polygon (MATIC)?”).",
            "Estudias el contenido (video, artículo, infografía).",
            "Respondes un quiz corto.",
            "Recibes una fracción de esa criptomoneda (entre $1 y $3 USD en tokens).",
          ],
        },
        {
          type: "paragraph",
          text: "💡 Estas recompensas sirven como incentivo y también te permiten practicar cómo funciona una wallet, una red y cómo interactuar con tokens reales.",
        },
      ],
    },
    {
      id: "plataformas",
      navLabel: "Plataformas populares",
      title: "🌐 Plataformas populares",
      content: [
        {
          type: "paragraph",
          text: "✅ Coinbase Learn & Earn",
        },
        {
          type: "list",
          items: [
            "Plataforma: Coinbase Learn & Earn",
            "Idioma: Inglés (algunos cursos con subtítulos)",
            "Recompensas: USDC, MATIC, XLM, entre otros.",
            "Requisitos: Verificar identidad (KYC), tener una cuenta activa en Coinbase.",
            "Ventajas: Plataforma reconocida y fácil de usar para principiantes.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Binance Learn & Earn",
        },
        {
          type: "list",
          items: [
            "Plataforma: Binance Learn & Earn",
            "Idioma: Español, inglés y otros.",
            "Recompensas: Varían según el proyecto (ALGO, BNB, SUI, etc.).",
            "Requisitos: Cuenta verificada en Binance. Algunas campañas requieren staking de BNB.",
            "Ventajas: Ofertas frecuentes. Interface amigable y segura.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Stellar Quest",
        },
        {
          type: "list",
          items: [
            "Plataforma: Stellar Quest",
            "Idioma: Inglés (explicaciones visuales).",
            "Recompensas: XLM (Stellar Lumens).",
            "Requisitos: Crear una wallet compatible (ex: Freighter), seguir los retos técnicos.",
            "Ventajas: Ideal para quienes desean aprender haciendo. Enseña conceptos técnicos desde el nivel 0, como crear y firmar transacciones en la red Stellar.",
          ],
        },
      ],
    },
    {
      id: "consideraciones",
      navLabel: "¿Qué tener en cuenta?",
      title: "⚠️ ¿Qué tener en cuenta antes de participar?",
      content: [
        {
          type: "list",
          items: [
            "Verifica siempre que el sitio sea oficial. Hay sitios falsos que imitan las plataformas reales.",
            "No compartas tu frase semilla (seed phrase) nunca, aunque te prometan más recompensas.",
            "Lee los términos de cada campaña. Algunas solo están disponibles en ciertos países o por tiempo limitado.",
            "Usa correos seguros y wallets protegidas. ¡Tu seguridad es tu responsabilidad!",
          ],
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad",
      title: "📝 Actividad – Aprende y reflexiona",
      content: [
        {
          type: "orderedList",
          items: [
            "Elige una mini-lección activa en una de las plataformas recomendadas arriba.",
            "Completa el quiz y recibe tu primera cripto-recompensa.",
            "Luego, en tu cuaderno, responde:",
          ],
        },
        {
          type: "list",
          items: [
            "¿Qué aprendiste sobre ese proyecto?",
            "¿Te resultó fácil o difícil entenderlo?",
            "¿Qué harías con esa pequeña cantidad que ganaste?",
            "¿Crees que este modelo motiva a los jóvenes a aprender más sobre finanzas y tecnología?",
          ],
        },
      ],
    },
    {
      id: "ejemplo",
      navLabel: "Ejemplo real",
      title: "📌 Ejemplo real",
      content: [
        {
          type: "paragraph",
          text: "🌟 María, una estudiante de 20 años en México, completó tres lecciones en Coinbase Learn. Ganó $6 USD en USDC. Luego los usó para probar su primera wallet y hacer una transferencia entre amigos. Nunca antes había tenido criptomonedas. Hoy, sigue aprendiendo y ya considera ahorrar parte de su beca en stablecoins.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase final",
      title: "🧠 Frase final",
      content: [
        {
          type: "paragraph",
          text: "“En Web3, incluso tus aprendizajes pueden tener valor. Cada lección que completas te acerca a tu libertad financiera.”",
        },
      ],
    },
  ],
};

export default modulo7;
